import { css } from '@emotion/css';
import Color from 'styles/colors';

export const tabWrapper = css`
  position: relative;
  display: flex;
  align-items: center;
  position: sticky;
  top: 3rem;
  z-index: 10;
  background-color: ${Color.White};
`;

export const tabs = css`
  padding-right: 3rem;
  border-bottom-width: 1px;
  outline: 2px solid transparent;
  outline-offset: 2px;
  width: 100%;

  .MuiTabs-flexContainer {
    margin-left: 1.25rem;
  }
`;

export const tab = (selected: boolean) => css`
  outline: none !important;
  font-size: 1rem !important;
  font-weight: ${selected ? '700' : '500'} !important;
  color: ${selected ? Color.Gray['100'] : Color.Gray['70']} !important;
`;

export const categoryExpandingWrapper = css`
  position: absolute;
  right: 0;
  z-index: 20;
  padding-right: 1rem;
`;

export const categoryExpandingButton = (rotate180: boolean) => css`
  cursor: pointer;
  transform: ${rotate180 ? 'rotate(180deg)' : 'rotate(0deg)'};
`;

export const dimmedBackgroundView = css`
  position: fixed;
  top: 0;
  background-color: ${Color.BlackAlpha['70']};
  width: 100%;
  max-width: 36rem;
  height: 100%;
  z-index: 3;
`;

export const categoryPanel = css`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  position: sticky;
  top: 6rem;
  z-index: 10;
  max-width: 36rem;
  background-color: ${Color.Gray['20']};
  padding: 1.25rem;
`;

export const categoryPanelItem = (selected: boolean) => css`
  cursor: pointer;
  border-radius: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.875rem;
  padding: 0.75rem;
  border: 1px solid ${selected ? Color.Primary : Color.Gray['30']};
  background-color: ${selected ? Color.Blue['20'] : Color.White};
  color: ${Color.Gray['100']};
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
`;
